import { AloftPrice } from '@aloft/shared-objects';
import { orUndefined, schAloftPrice } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectHasArvOption } from './orderSelectors.ts';
import { selectReconciliation } from './selectReconciliation.ts';

export const selectEstimatedROI = createSelector(
  [selectHasArvOption, selectReconciliation],
  (hasArvOption, reconciliation) => {
    const opinionOfMarketValue = orUndefined(schAloftPrice.parse)(
      reconciliation.opinionOfMarketValue,
    );
    const opinionOfAfterRepairValue = orUndefined(schAloftPrice.parse)(
      reconciliation.opinionOfAfterRepairValue,
    );
    const totalRenovationBudget = orUndefined(schAloftPrice.parse)(
      reconciliation.totalRenovationBudget,
    );

    if (!hasArvOption || !opinionOfAfterRepairValue || !opinionOfMarketValue) {
      return undefined;
    }

    const renovationBudget = totalRenovationBudget ?? AloftPrice.zero;
    return opinionOfAfterRepairValue.sub(opinionOfMarketValue).sub(renovationBudget);
  },
);
